import PrivacyTermsInfo from "./privacy-terms-info";

export default PrivacyTermsInfo;
